module.exports = __webpack_public_path__ + "img/img8.8ac8fe76.svg";